<script>
    // Import axios for API consuming in a clean interface.
    import axios from 'axios';

    // Import animated counter component
    import Vue3Autocounter from 'vue3-autocounter';

    export default {
        components: {
            Vue3Autocounter,
        },
        props: {
            data: Object,
            phases: Array,
            filterItems: Array,
        },
        data() {
            return {
                facetAlias: 'fase_label_aantal_dagen_doorlooptijd_lopend',
                facetAliasSum: 'aantal_dagen_doorlooptijd_lopend',
                loading: false,
                limit: 0,
                offset: 0,
                dataArrangements: null,
                dataDeductions: null,
            }
        },
        async created() {
            this.loading = true;

            try {
                const api = this.$store.getters.getText('dashboardApiEndpointArrangements');

                const response = await axios.post(
                    api,
                    {
                        Limit: this.limit,
                        Offset: this.offset,
                        Text: '',
                        FilterItems: this.filterItems,
                    }
                );
                if (!response || response.status != 200 || !response.data) throw 'no response or bad status';
                this.dataArrangements = response.data;
            } catch (error) {
                console.error('Error loading JSON data: ', error);
            }

            try {
                const api = this.$store.getters.getText('dashboardApiEndpointDeductions');

                const response = await axios.post(
                    api,
                    {
                        Limit: this.limit,
                        Offset: this.offset,
                        Text: '',
                        FilterItems: this.filterItems,
                    }
                );
                if (!response || response.status != 200 || !response.data) throw 'no response or bad status';
                this.dataDeductions = response.data;
            } catch (error) {
                console.error('Error loading JSON data: ', error);
            }

            this.loading = false;
        },
        methods: {
            getAmount(phase, type) {
                const data = type === 'arrangements' ? this.dataArrangements : this.dataDeductions;
                if (!data || !data.facets || !data.facets.length) return 0;
                const facet = data.facets.find(f => f.alias === this.facetAlias);
                if (!facet || !facet.options || !facet.options.length) return 0;
                const options = facet.options.filter(o => o.valueAlias.includes(phase.label));
                if (!options.length) return 0;
                return options.reduce((sum, o) => sum + o.filteredAmount, 0);
            },
            getAvgTurnaroundTime(phase) {
                if (!this.data || !this.data.facets || !this.data.facets.length) return 0;
                const facet = this.data.facets.find(f => f.alias === this.facetAlias);
                if (!facet || !facet.options || !facet.options.length) return 0;
                const options = facet.options.filter(o => o.valueAlias.includes(phase.label));
                if (!options || !options.length) return 0;
                const turnaroundDays = options.map(o => o.sums[this.facetAliasSum]).reduce((sum, a) => sum + a, 0);
                const amount = options.map(o => o.filteredAmount).reduce((sum, a) => sum + a, 0);
                const averageTurnaroundDays = turnaroundDays / amount;
                const average = Math.round(averageTurnaroundDays / 30.4 * 10) / 10;
                return isNaN(average) ? 0 : average;
            },
        }
    };
</script>

<template>
    <div v-if="loading" class="has-text-centered">
        <div class="lds-facebook has-text-grey-lighter">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div v-else class="dashboard-widget">
        <table class="table table--matrix is-bordered">
            <thead>
                <tr>
                    <th></th>
                    <th v-for="phase in phases" 
                        :key="`label-${phase.label}`"
                        :style="{ 
                            backgroundColor: $store.getters.getHighContrast ? '#ffffff' : phase.backgroundColor,
                            color: $store.getters.getHighContrast ? '#000000' : '#ffffff'
                        }">
                        {{ phase.label }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th>{{ $store.getters.getText('dashboardTabArrangements') }}</th>
                    <td v-for="phase in phases" 
                        :key="`arrangements-${phase.label}`"
                        :style="{ borderColor: $store.getters.getHighContrast ? '#000000' : phase.backgroundColor }"
                        class="has-text-centered">
                        <vue3-autocounter :endAmount="getAmount(phase, 'arrangements')" separator="." duration="0.5" />
                    </td>
                </tr>
                <tr>
                    <th>{{ $store.getters.getText('dashboardTabDeductions') }}</th>
                    <td v-for="phase in phases" 
                        :key="`deductions-${phase.label}`"
                        :style="{ borderColor: $store.getters.getHighContrast ? '#000000' : phase.backgroundColor }"
                        class="has-text-centered">
                        <vue3-autocounter :endAmount="getAmount(phase, 'deductions')" separator="." duration="0.5" />
                    </td>
                </tr>
                <tr>
                    <th>{{ $store.getters.getText('dashboardWidgetTurnaround') }}</th>
                    <td v-for="phase in phases" 
                        :key="`turnaround-${phase.label}`"
                        :style="{ borderColor: $store.getters.getHighContrast ? '#000000' : phase.backgroundColor }"
                        class="has-text-centered">
                        <vue3-autocounter :endAmount="getAvgTurnaroundTime(phase)" separator="." duration="0.5" />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
